/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Link } from 'react-router-dom';
import createTrack from 'services/actions/tracker_actions';
import { useDispatch, useSelector } from 'react-redux';
import { get_info_bidding, validate_contract } from 'store/modules/contract_analysis/actions';
import { ApplicationState } from 'store';
import { ContractsAnalysisState } from 'store/modules/contract_analysis/types';
import ContractAnalysisForm from 'components/organisms/contract_analysis_form';
import AmbassadorToolFeedback from 'components/molecules/ambassador_tool_feedback';
import { CONTRACT_CLAUSES_AMBASSADOR_SLUG } from 'services/ambassador_tools';

const NewContractAnalysis = () => {
  const dispatch = useDispatch();

  const { contract_analysis, request } = useSelector<ApplicationState, ContractsAnalysisState>(
    (state) => state.session.contract_analysis,
  );

  return (
    <div className="page-container">
      <div className="container-fluid big-resolutions">
        <div className="row mb-4 px-md-4 pt-4">
          <div className="col-md-12">
            <Link
              to="/validar_contrato"
              className="btn btn-link p-0 btn-sm d-flex align-items-center mb-2"
              onClick={() =>
                createTrack('Clicou no botão voltar', {
                  fonte: 'Análise de contrato',
                })
              }
            >
              <i className="material-icons mr-1">arrow_back_ios</i>
              Voltar
            </Link>

            <h3 className="mb-1">Nova Análise</h3>
            <p className="text-muted mb-4">Envie os documentos para análise de conformidade.</p>

            <ContractAnalysisForm
              bidding={contract_analysis?.bidding}
              biddingLoading={request?.bidding?.loading}
              onSearchBidding={(biddingId) => dispatch(get_info_bidding(biddingId))}
              submitting={request?.validate_contract?.loading}
              onSubmit={(payload) => dispatch(validate_contract(payload))}
            />
          </div>
        </div>
      </div>
      <AmbassadorToolFeedback toolSlug={CONTRACT_CLAUSES_AMBASSADOR_SLUG} />
    </div>
  );
};

export default NewContractAnalysis;
